import { RMRectangle } from 'business/models/CustomModels';
import React, { useMemo } from 'react';
import {
  useHitScoreGroupType,
  useSelectedHitButton,
  useSelectedHitScoreGroups,
  useUvHitsOnly,
} from 'redux/hooks/header';
import { ESelectedHitButton } from 'redux/reducers/headerReducer';
import { IScoresOfWellDropsDTO } from 'business/models/Models';
import { CompositeRectsShape } from 'components/canvas/compositeRectsShape';
import { ScoresOfWellDrops } from 'components/Experiment/constants';
import { ScoreGroupType } from 'components/Experiment/FindDrop/Contants';
import { scoresMatchHitsFilter } from 'components/Experiment/FindDrop/ScoringFilters/hitsFilterUtils';

type UseDrawHitsProps = {
  wellDrops: any[];
  scores: { [key: string]: IScoresOfWellDropsDTO[] };
  wellRectangles: RMRectangle[];
};
const BatchIdLabel = 'Capture Result.Image Batch ID';

export const HitRectangles = (props: UseDrawHitsProps) => {
  const { wellDrops, scores, wellRectangles } = props;
  const hitScoreGroups = useSelectedHitScoreGroups();
  const hitScoreGroupType = useHitScoreGroupType();
  const hitButton = useSelectedHitButton();
  const uvHitsOnly = useUvHitsOnly();

  const hitRectangles = useMemo(() => {
    const hitsFilterActive = hitButton !== ESelectedHitButton.None || uvHitsOnly;
    if (!hitsFilterActive || !wellDrops.length || !scores) {
      return [];
    }

    const requireAllHits = hitButton === ESelectedHitButton.AllHits;
    const scoreGroupType = (hitScoreGroupType as ScoreGroupType) || ScoreGroupType.All;
    const rects: RMRectangle[] = [];

    for (let i = 0; i < wellDrops.length; i++) {
      const dropId = wellDrops[i].__WellDropID ?? wellDrops[i]['Well Drop.ID'];
      const batchId = wellDrops[i][BatchIdLabel];
      if (!dropId || !batchId) {
        continue;
      }

      const rect = (
        wellRectangles[i] as {
          props?: { x: number; y: number; width: number; height: number };
        }
      )?.props;
      if (!rect) {
        continue;
      }

      const wellScores = scores[`${dropId}-${batchId}`] as
        | ScoresOfWellDrops[]
        | undefined;
      const isHitDrop = scoresMatchHitsFilter(
        wellScores,
        hitScoreGroups,
        scoreGroupType,
        requireAllHits,
        uvHitsOnly,
      );

      if (!isHitDrop) {
        rects.push({
          x: rect.x + 1,
          y: rect.y,
          w: rect.width - 2,
          h: rect.height,
        });
      }
    }

    return rects;
  }, [
    wellDrops,
    scores,
    wellRectangles,
    hitButton,
    hitScoreGroups,
    hitScoreGroupType,
    uvHitsOnly,
  ]);

  return <CompositeRectsShape rectangles={hitRectangles} />;
};
